// src/pages/HomePage/HomePage.jsx

import React from 'react';

// Import Section Components
import Hero from '../../components/sections/Hero/Hero';
import FeaturedServices from '../../components/sections/FeaturedServices/FeaturedServices';
import OurValues from '../../components/sections/OurValues/OurValues';
import Testimonials from '../../components/sections/Testimonials/Testimonials';
import Cta from '../../components/sections/Cta/Cta';
import Services from '../../components/sections/Services/Services'
import MaterialsShowcase from '../../components/sections/MaterialsShowcase/MaterialShowcase';
import BeforeAfter from '../../components/sections/BeforeAfter/BeforeAfter';
import DesignGallery from '../../components/sections/DesignGallery/DesignGallery';
import Pricing from '../../components/sections/Pricing/Pricing';
import Gallery from '../../components/sections/Gallery/Gallery';
import WhyChooseUs from '../../components/sections/WhyChooseUs/WhyChooseUs';
import FAQ from '../../components/sections/FAQ/FAQ';
import MaterialGallery from '../../components/sections/MaterialGallery/MaterialGallery';
import Clients from '../../components/sections/Clients/Clients';
import IndustryExpertise from '../../components/sections/IndustryExpertise/IndustryExpertise';
import Contact from '../../components/sections/Contact/Contact';
const HomePage = () => {
    return (
        <div> {/* FIX: Applies padding here instead of App.jsx */}
            <Hero />
<FeaturedServices />
            <DesignGallery />
                      <WhyChooseUs />
            <BeforeAfter />
            <IndustryExpertise />
         <Services />
                     <Gallery />
            <Pricing />
            <Clients />
             <Testimonials />
            <OurValues />
            <Cta />
            <MaterialsShowcase />
            <MaterialGallery />
            <FAQ />
            <Contact />
        </div>
    );
};

export default HomePage;